
import {
    describeAppliesTo,
    describePlanStates,
    describeStates,
    planAka,
    planDisplayName,
    planTypeText,
} from '~/util/plan-notes'

// The Plan Notes page's Plans tab: the year's catalog plans for the filters,
// each with the notes a quote's card for it would carry.
export default {
    props: {
        items: { type: Array, default: () => [] },
        loading: { type: Boolean, default: false },
        error: { type: String, default: null },
    },
    data () {
        return {
            open: {},
            fields: [
                { key: 'plan', label: 'Plan', thStyle: { width: '30%' } },
                { key: 'carrier', label: 'Carrier' },
                { key: 'type', label: 'Type' },
                { key: 'states', label: 'States' },
                { key: 'notes', label: 'Notes', thStyle: { width: '30%' } },
                { key: 'actions', label: '' },
            ],
        }
    },
    methods: {
        describeAppliesTo,
        describePlanStates,
        describeStates,
        planAka,
        planName: planDisplayName,
        planTypeText,
    },
}
